import(/* webpackMode: "eager" */ "/var/www/project/git/fe_bolsasocial_js/app/features/web/footer/footer.tsx");
import(/* webpackMode: "eager" */ "/var/www/project/git/fe_bolsasocial_js/app/features/web/Header/webHeader.tsx")